import { BaseModel } from "ReduxStore/index";

export interface OfferIds {
  offerIds: number[];
}

export default class SortedFavouriteOfferIds extends BaseModel<OfferIds> {
  static resource = "SortedFavouriteOfferIds";
}
